import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { GrantsService } from 'src/app/services/grants.service';

@Directive({ selector: '[hasGrants]' })
export class GrantDirective {
  private hasView = false;

  private elseTemplate?: TemplateRef<any>;
  grantsArray: string[] = [];
  @Input()
  set hasGrantsElse(template: TemplateRef<any> | null) {
    this.elseTemplate = template ?? undefined;
    this.hasView = false;
    this.updateView();
  }
  @Input() set hasGrants(grants: string | string[]) {
    this.grantsArray = Array.isArray(grants) ? grants : [grants];
    this.updateView();
  }

  constructor(
    private grantsService: GrantsService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  updateView() {
    const hasAccess = this.checkGrants(this.grantsArray);
    if (!this.hasView) {
      this.viewContainer.clear();
      if (hasAccess) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      } else if (this.elseTemplate) {
        this.viewContainer.createEmbeddedView(this.elseTemplate);
        this.hasView = true;
      }
    }
  }

  checkGrants(grants: string[]): boolean {
    return checkGrants(grants, this.grantsService.grantList);
  }

  ngOnDestroy(): void {
    this.viewContainer.clear();
  }
}

export const checkGrants = (grants: string[], myGrants: string[]): boolean => {
  const allGrants = grants.reduce(
    (acc, el) => {
      if (!el.endsWith('.*')) {
        // USERS.C <- finisce per .*? Se sì, l'aggiungo, se no creo un nuovo grant che finisce per .* (USERS.*)
        acc.push(`${el.split('.')[0]}.*`); // 'USERS.C'.split('.') -> ['USERS', 'C'] - [0] -> USERS
      }
      acc.push(el);
      return acc;
    },
    ['*']
  );
  return allGrants.some(el => {
    return myGrants.includes(el);
  });
};
